// Build a wa.me URL from a phone number (with optional country code prefix).
// Falls back to the provided business number when guest phone is missing.
export const buildWhatsAppUrl = (countryCode, phoneNumber, fallback) => {
  const digitsOnly = (v) => String(v || "").replace(/[^\d]/g, "");
  const codeDigits = digitsOnly(countryCode);
  const phoneDigits = digitsOnly(phoneNumber);
  let target = "";
  if (phoneDigits) {
    target = `${codeDigits}${phoneDigits}`;
  } else if (fallback) {
    target = digitsOnly(fallback);
  }
  if (!target) return null;
  return `https://wa.me/${target}`;
};

// Build a wa.me URL to the business number with a pre-filled text message.
export const buildWhatsAppMessageUrl = (businessNumber, message) => {
  const digitsOnly = (v) => String(v || "").replace(/[^\d]/g, "");
  const target = digitsOnly(businessNumber);
  if (!target) return null;
  const params = message ? `?text=${encodeURIComponent(message)}` : "";
  return `https://wa.me/${target}${params}`;
};
